import { render, staticRenderFns } from "./tkEdit.vue?vue&type=template&id=271f9c0c&scoped=true&"
import script from "./tkEdit.vue?vue&type=script&lang=js&"
export * from "./tkEdit.vue?vue&type=script&lang=js&"
import style0 from "./tkEdit.vue?vue&type=style&index=0&id=271f9c0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f9c0c",
  null
  
)

export default component.exports